import { formatNumberWithSeparator } from 'utils/amount';

export function formatOpportunityCount(value, { fallback = '-' } = {}) {
    if (value === null || value === undefined) return fallback;
    if (value === '') return '';

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return String(value);

    return formatNumberWithSeparator(Math.round(numericValue));
}
